module.exports = __webpack_public_path__ + "assets/zongheshenpi.107f1120.svg";